import { render, staticRenderFns } from "./RotationPopup.vue?vue&type=template&id=6ef954ac&scoped=true"
import script from "./RotationPopup.vue?vue&type=script&lang=js"
export * from "./RotationPopup.vue?vue&type=script&lang=js"
import style0 from "./RotationPopup.vue?vue&type=style&index=0&id=6ef954ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef954ac",
  null
  
)

export default component.exports